import { facadeApi } from 'api'
import { WrikeAuthParams } from 'types/wrike'

export const fetchWrikeAuthAuthenticateApi = (params: WrikeAuthParams) =>
  facadeApi.get('wrike/auth/authenticate', {
    params,
  })
